import {useParams} from 'react-router-dom';
import {JKUserFreeLogManager} from '../JKUser/FreeLog/Manager';

export const BackendPointDetail = () => {
  const {id} = useParams<any>();
  return <JKUserFreeLogManager cardId={id} />;
};
